// Телефонная локаль подбирается по домену кабинета: на российских доменах
// (*.ru, например test2.listli.ru) показываем +7 и ждём 10 цифр после кода,
// на остальных (edskills.by и т.п.) — +375 и 9 цифр.
const isRussianDomain = window.location.hostname.endsWith(".ru");

export const PHONE_LOCALE = isRussianDomain
  ? { prefix: "+7", code: "7", digits: 10, placeholder: "9161234567" }
  : { prefix: "+375", code: "375", digits: 9, placeholder: "291112233" };
